<template>
  <Page>
    <session class="page-home">
      <div class="block-wrap block1-wrap" id="aboutus" :style="{ backgroundImage: `url(${IMG_COVER_BANNER})` }">
        <div class="container">
          <div class="block1-content">
            <span>PaperWonder</span>
            <span>设计创作</span>
          </div>
        </div>
      </div>
      <div class="block-wrap block2-wrap">
        <div class="container">
          <div class="block2-about">
            <span>PaperWonder是一个将创作全过程（设计创作、印刷生产、活动展览、贩售）置入其中的复合空间与品牌</span>
          </div>
        </div>
      </div>

      <div class="block-wrap block3-wrap" id="intro">
        <div class="container">
          <div class="block-cover" :style="{ backgroundImage: `url(${IMG_COVER_3})` }" />
          <div class="block-content">
            <div class="title">
              <span>PaperWonder带来活力的创作方式</span>
            </div>
            <div class="detail">从灵感的迸发、对印刷材料的探索实践，到搭建向外发声的窗口（展览、交流与贩售），我们希望为创作提供更短的实践路径，带来具有活力和可持续性的的创作方式。</div>
          </div>
        </div>
      </div>

      <div class="block-wrap block4-wrap">
        <div class="container">
          <div class="block-cover" :style="{ backgroundImage: `url(${IMG_COVER_4})` }" />
          <div class="block-content">
            <div class="title">
              <span>专业的印刷团队</span>
            </div>
            <div class="detail">旗下印刷支持部门“本色数印 NCOLOR PRINT”成立于2002年，拥有专业的印刷团队与上万种可供选择的纸张。为创作者提供高品质、灵活的印刷解决方案与咨询服务。</div>
          </div>
        </div>
      </div>
      
      <div class="block-wrap block5-wrap">
        <div class="container">
          <div class="block-cover" :style="{ backgroundImage: `url(${IMG_COVER_5})` }" />
          <div class="block-content">
            <div class="title">
              <span>创作者的游乐园</span>
            </div>
            <div class="detail">以“创作者的游乐园”为目标，“PaperWonder”App将辅助每个创作者用轻快便捷的方式地进行表达，共同延展出品牌的更多可能性。</div>
          </div>
        </div>
      </div>

<!--      <div class="block-wrap block6-wrap" id="download">-->
<!--        <div class="container">-->
<!--          <div class="download-title">下载APP</div>-->
<!--          <div class="download-message">-->
<!--            <div class="download-message-l">-->

<!--              <div class="download-divice">-->
<!--                <div class="download-divice-t">-->
<!--                  <div class="download-divice-icon ios" />-->
<!--                  <div class="download-divice-name"><span>App Store</span><span>下载</span></div>-->
<!--                </div>-->
<!--                <div class="download-divice-b"><img src="./images/qrcode-ios.png" /></div>-->
<!--              </div>-->

<!--              <div class="download-divice">-->
<!--                <div class="download-divice-t">-->
<!--                  <div class="download-divice-icon android" />-->
<!--                  <div class="download-divice-name"><span>Android</span><span>下载</span></div>-->
<!--                </div>-->
<!--                <div class="download-divice-b"><img src="./images/qrcode-android.png" /></div>-->
<!--              </div>-->

<!--            </div>-->
<!--            <div class="download-message-r"><img src="./images/download-cover.png" /></div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </session>
  </Page>
</template>

<script setup>
  import Page from '@/components/page';

  import IMG_COVER_BANNER from './images/banner.png';
  import IMG_COVER_3 from './images/cover3.png';
  import IMG_COVER_4 from './images/cover4.png';
  import IMG_COVER_5 from './images/cover5.png';
</script>

<style scoped lang="less">
@import "index.less";
</style>
